// --------------------------------------------------------------
// Created On: 2024-03-28
// Author: Zachary Thomas
//
// Last Modified: 2024-03-28
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// This is an input field that accepts phone numbers.
export default function PhoneNumberInput(props: Props): Component {
  function updatePhoneNumber(phoneNumber: string, country: Record<string, never> | CountryData): void {
    props.onPhoneNumberChange(phoneNumber);
    if ("dialCode" in country) {
      props.onCallingCodeChange(country.dialCode);
    }
  }

  return (
    <div>
      <label className="mb-3 font-weight-bold">Phone Number</label>
      <PhoneInput
        placeholder="Enter phone number..."
        value={props.phoneNumber}
        country={props.callingCode}
        onChange={(phoneNumber, country) => updatePhoneNumber(phoneNumber, country)}
      />
    </div>
  );
}

PhoneNumberInput.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  callingCode: PropTypes.string.isRequired,
  onPhoneNumberChange: PropTypes.func.isRequired,
  onCallingCodeChange: PropTypes.func.isRequired,
};

interface Props {
  phoneNumber: string;
  callingCode: string;
  onPhoneNumberChange: (phoneNumber: string) => void;
  onCallingCodeChange: (callingCode: string) => void;
}

interface CountryData {
  name: string;
  dialCode: string;
  countryCode: string;
}
